import { useEffect, useRef } from 'react'
import prefersReducedMotion from '@/shared/tools/prefersReducedMotion'
import usePulseScope from './usePulseScope'

const REVEAL_KEYFRAMES: Keyframe[] = [
  { opacity: 0, transform: 'translateY(4px)' },
  { opacity: 1, transform: 'translateY(0)' },
]

const usePulseReveal = (trigger: unknown) => {
  const isPulse = usePulseScope()
  const frameRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const frame = frameRef.current
    if (!frame || typeof frame.animate !== 'function' || prefersReducedMotion()) return
    frame.animate(REVEAL_KEYFRAMES, { duration: 150, easing: 'ease' })
  }, [trigger])

  return { isPulse, frameRef }
}

export default usePulseReveal
